<template>
    <md-list-item ref="colorPicker" class="ql-layer-menu-item">
        <md-button class="ql-color-picker-choice" :style="style()" @click.stop.prevent="toggleVisibility">
            <md-icon v-if="!viewable">visibility_off</md-icon>
            <md-icon v-if="viewable && !showNotes">speaker_notes_off</md-icon>
            <md-icon v-else></md-icon>
        </md-button>
        <form novalidate @submit.stop.prevent="saveTitle" @keyup.stop.prevent="keyPress" v-if="editable">
            <span v-if="!editing" @click="edit()">{{layer.title}}
                <md-tooltip md-direction="top" >click to edit title</md-tooltip>
            </span>
            <md-input-container v-if="editing">
                <md-input v-model="layer.title" :value="layer.title" @click.stop.prevent></md-input>
            </md-input-container>
        </form>
        <span style="width:100%; padding-left: 15px" v-else> {{layer.title}}
            <md-tooltip md-direction="top">No Edit Permissions</md-tooltip>
        </span>
        <md-button class="md-icon-button md-list-action" @click.stop.prevent="saveTitle" v-if="editing">
            <md-icon>save</md-icon>
        </md-button>
        <md-list-expand>
            <md-list class="sub-list">
                <md-list-item v-if="viewable" @click="hide">
                    Hide Layer
                </md-list-item>
                <md-list-item v-if="!viewable" @click="show">
                    Show Layer
                </md-list-item>
                <md-list-item v-if="showNotes" @click="hideText">
                    Hide Text
                </md-list-item>
                <md-list-item v-if="!showNotes" @click="showText">
                    Show Text
                </md-list-item>
                <md-list-item v-if="editable">
                    Change Color
                    <md-list-expand>
                        <md-list>
                            <md-list-item>
                                <color-picker v-model="colors" @input="pickColor"/>
                                <md-tooltip md-direction="top">click to change color theme</md-tooltip>
                            </md-list-item>
                        </md-list>
                    </md-list-expand>
                </md-list-item>

                <md-list-item @click="deleteLayer" v-if="editable">
                    Delete this layer 
                    <md-icon>delete</md-icon>
                </md-list-item>
            </md-list>
            
        </md-list-expand>
    </md-list-item>
</template>

<script>
/**
 * https://github.com/xiaokaike/vue-color/blob/master/src/components/Swatches.vue
 */
// import { mapGetters } from 'vuex';
import { Slider } from 'vue-color';

const LayersLayer = {
    name: 'LayersLayer',
    props: ['layer', 'viewable', 'editable', 'showNotes', 'project'],
    data: function() {
        return {
            editing: false,
            selectedColor: '',
            showingPicker: false,
            colors: {},
            oldTitle: this.$props.layer.title
        };
    },
    computed: {
    },
    methods: {
        edit() {
            if (this.editable) {
                this.editing = true;
            }
        },
        done() {
            this.editing = false;
        },
        style() {
            let val = 'background-color: white;';
            if (this.layer.color) {
                val = 'background-color: ' + this.layer.color + ' !important;';
            }
            return val;
        },
        keyPress(e) {
            if (e.keyCode === 27) {
                this.editing = false;
                this.$props.layer.title = this.oldTitle;
            }
        },
        saveTitle() {
            this.editing = false;
            this.oldTitle = this.$props.layer.title;
            this.$emit('updateLayer', this.layer);
        },
        pickColor(e) {
            this.layer.colorDetails = e;
            this.layer.color = this.layer.colorDetails.hex;
            this.$emit('updateLayer', this.layer);
        },
        deleteLayer() {
            this.$emit('deleteLayer', this.layer);
        },
        toggleVisibility() {
            if (this.viewable) {
                this.hide();  
            } else {
                this.show();
            }
        },
        show() {
            this.$emit('showLayer', this.layer);
        },
        hide() {
            this.$emit('hideLayer', this.layer);
        },
        showText() {
            // this.$emit('showText', this.layer);
            this.$store.dispatch('showNotes', this.layer);
        },
        hideText() {
            // this.$emit('hideText', this.layer);
            this.$store.dispatch('hideNotes', this.layer);
        }
    },
    components: {
        'color-picker': Slider
    }
};
export default LayersLayer;

</script>

<style lang="scss">
.vc-compact {
    margin: 10px 0;
}
.ql-color-picker {
    width: 100%;
    display: block;
    clear: both;
}
.ql-color-picker-choice {
    margin: 0;
    padding: 0;
    width: 25px;
    height: 25px;
    min-height: 25px;
    min-width: 25px;
    line-height: 25px;
    box-sizing: border-box;
    border: 1px solid black !important;
}
.ql-layer-menu-item {
    form {
        z-index: 100;
        text-align: left;
        width: calc(100% - 1em);
        margin-left: 1em;
        span {
            text-align: left;
            margin-left: 0;
            width: 100%;
            height: 100%;
            display: inline-block;
        }
    }
    .sub-list {
        .md-list-item .md-list-item-container > .md-icon:first-child {
            margin-right: 0px;
        }
        margin-left: 16px;
        width: calc(100% - 16px);
    }
}
</style>


// WEBPACK FOOTER //
// layer.vue?f003f0d4